export const INITIAL_STATE = {
    name: '',
    imgUrl: '',
    description: '',
    apiErrorResponse: null,
    apiSuccessResponse: null,
    isSuccess: false,
    loading: false,
    isFailed: false,
    showCancelPopup: false,
    changes: false,
    fieldErrors: {},
};

export const TOAST_MESSAGES = {
    success: 'Category created successfully!',
    error: 'Failed to create category. Please try again.',
};

export const VALIDATION_ERROR_MESSAGES = {
    name: 'Category name is required.',
    imgUrl: 'Image URL is required.',
    description: 'Description is required.',
};

export const CATEGORY_FORM_FIELDS = [
    {
        name: 'name',
        label: 'Name',
        type: 'text',
        placeholder: 'Enter category name',
        required: true,
        validationMessage: 'Category name is required.',
        maxLength: 50,
    },
    {
        name: 'imgUrl',
        label: 'Image URL',
        type: 'text',
        placeholder: 'https://example.com/sample_image.png',
        required: true,
        validationMessage: 'Image URL is required.',
        maxLength: 240,
    },
    {
        name: 'description',
        label: 'Description',
        type: 'textarea',
        placeholder: 'Enter description',
        required: true,
        validationMessage: 'Description is required.',
        maxLength: 320,
    },
];

// Validate that URL starts with https://
export const validateUrlField = (url) => {
    if (!url || url.trim() === '') {
        return null;
    }
    if (!url.startsWith('https://')) {
        return 'URL must start with https://';
    }
    return null;
};

export const validateForm = (state) => {
    const errors = {};

    if (!state.name || state.name.trim() === '') {
        errors.name = VALIDATION_ERROR_MESSAGES.name;
    }

    if (!state.imgUrl || state.imgUrl.trim() === '') {
        errors.imgUrl = VALIDATION_ERROR_MESSAGES.imgUrl;
    } else {
        const urlError = validateUrlField(state.imgUrl);
        if (urlError) {
            errors.imgUrl = urlError;
        }
    }

    if (!state.description || state.description.trim() === '') {
        errors.description = VALIDATION_ERROR_MESSAGES.description;
    }

    return errors;
};
